import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBuilding = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.205 2a.75.75 0 0 0-.75.75V20.5H2.75a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-.56V7.016a.75.75 0 0 0-.75-.75h-5.247a.75.75 0 0 0-.75.75v3.523h-3.74V2.75a.75.75 0 0 0-.75-.75zm9.738 10.039V20.5h-3.74v-8.461zm1.5-.761V7.766h3.747V20.5h-3.747v-9.222m-6.747.011q0-.052.006-.1V3.5H4.955v17h3.74zM5.325 7.023a.75.75 0 0 1 .75-.75h1.507a.75.75 0 0 1 0 1.5H6.075a.75.75 0 0 1-.75-.75m5.247 7.203a.75.75 0 0 1 .75-.75h1.507a.75.75 0 0 1 0 1.5h-1.507a.75.75 0 0 1-.75-.75m.75 2.623a.75.75 0 0 0 0 1.5h1.507a.75.75 0 0 0 0-1.5zm4.497-2.623a.75.75 0 0 1 .75-.75h1.508a.75.75 0 0 1 0 1.5h-1.508a.75.75 0 0 1-.75-.75m.75 2.623a.75.75 0 0 0 0 1.5h1.508a.75.75 0 0 0 0-1.5zM5.325 14.226a.75.75 0 0 1 .75-.75h1.507a.75.75 0 0 1 0 1.5H6.075a.75.75 0 0 1-.75-.75m.75 2.623a.75.75 0 0 0 0 1.5h1.507a.75.75 0 0 0 0-1.5zm0-6.739a.75.75 0 0 0 0 1.5h1.507a.75.75 0 0 0 0-1.5zm9.744.75a.75.75 0 0 1 .75-.75h1.508a.75.75 0 0 1 0 1.5h-1.508a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBuilding;
